<template>
  <div class="handset-product">
    <!-- <span v-if="product.tag" class="handset-product__tag">{{
      product.tag
    }}</span> -->
    <img
      :src="require(`@/${product.img}`)"
      class="handset-product__img"
    >
    <div class="handset-product__content">
      <p class="handset-product__title">
        {{ product.title }}
      </p>
      <div class="handset-product__info">
        <p class="handset-product__info__item">
          {{ product.lines }}
        </p>
        <p class="handset-product__info__item">
          {{ product.ethernetPort }}
        </p>
        <p class="handset-product__info__item">
          {{ product.dimensions }}
        </p>
        <p v-if="product.extra" class="handset-product__info__item">
          {{ product.extra }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HandsetProduct',
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.handset-product {
  &__tag {
    border-radius: 0 6px 6px 6px;
    background-color: #000;
    color: #ffff;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 9px;
    letter-spacing: -0.48px;
    height: 16px;
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;

        @media (min-width: $screen-lg) {
    height: 20px;
    width: 160px;
        font-size: 12px;
        }
  }

  &__img {
    max-width: 100%;
  }

  &__content {
    position: relative;
    top: -10px;
  }

  &__title,
  &__info__item {
    text-align: left;
  }

  &__title {
    color: $bionic-navy;
    font-size: 14px;
    letter-spacing: -0.79px;
    margin: 0 0 10px 0;

    @media (min-width: $screen-lg) {
      margin: 0 0 13px 0;
      font-size: 20px;
    }
  }

  &__info {
    line-height: 14px;

    @media (min-width: $screen-lg) {
      line-height: 20px;
    }

    &__item {
      opacity: 0.8;
      color: $bionic-lightgrey;
      font-size: 10px;
      letter-spacing: 0px;
      margin: 0;

      @media (min-width: $screen-lg) {
        letter-spacing: -0.64px;
        font-size: 16px;
      }
    }
  }
}
</style>
